export enum CaseOverviewViewMode {
  Basic,
  Advanced,
  Custom,
  FinanceBasic,
  FinanceAdvanced
}
